"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fdatetime_1 = require("./fdatetime");
var dateParse_1 = require("./dateParse");
/**
 * dodaje określoną liczbę jednostek do daty
 * @param date data wejściowa
 * @param part częśc daty do zmiany
 * @param value o lie zwiększyć
 */
function dateAdd(date, part, value) {
    var inputDate = dateParse_1.default(date);
    var result = new Date(inputDate);
    switch (part) {
        case 'y':
        case 'yy':
        case 'yyyy':
        case 'year':
            result.setFullYear(inputDate.getFullYear() + value);
            break;
        // return padNumber(datePart('y', date) + value, 4) + date.substr(4);
        case 'M':
        case 'MM':
        case 'month':
            result.setMonth(inputDate.getMonth() + value);
            break;
        case 'd':
        case 'dd':
        case 'day':
            result.setDate(inputDate.getDate() + value);
            break;
        case 'h':
        case 'hh':
        case 'hour':
            result.setHours(inputDate.getHours() + value);
            break;
        case 'm':
        case 'mm':
        case 'minute':
            result.setMinutes(inputDate.getMinutes() + value);
            break;
        case 's':
        case 'ss':
        case 'second':
            result.setSeconds(inputDate.getSeconds() + value);
            break;
    }
    if (date.length === 10) {
        return fdatetime_1.default(result).replace(' 00:00:00', '');
    }
    else {
        return fdatetime_1.default(result);
    }
}
exports.default = dateAdd;
//# sourceMappingURL=dateAdd.js.map